import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  Guid,
  isEmptyString,
  isNil,
  Nillable,
  valueOrDefault,
} from '@web/utils';
import { Observable, of } from 'rxjs';
import { WarehouseGoodUsageStatus } from '../../enums/warehouse-good-usage-status';
import { WarehouseGoodUsage } from '../../models/warehouse-good-usage';
import { AdminWarehouseGoodDataSourceService } from '@web/features/warehouse';
import { WarehouseGoodType } from '../../enums/warehouse-good-type';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-warehouse-good-usage-status',
  imports: [CommonModule, Tooltip],
  templateUrl: './warehouse-good-usage-status.component.html',
  styleUrl: './warehouse-good-usage-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseGoodUsageStatusComponent {
  public readonly currentObjectId = input<Nillable<Guid>>();
  public readonly currentObjectType = input<Nillable<WarehouseGoodType>>();
  public readonly goodId = input<Nillable<Guid>>();

  protected readonly WarehouseGoodUsageStatus = WarehouseGoodUsageStatus;
  protected readonly valueOrDefault = valueOrDefault;

  protected usage$!: Observable<Nillable<WarehouseGoodUsage>>;

  public constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly warehouseGoodDataSourceService: AdminWarehouseGoodDataSourceService,
  ) {
    effect(() => this.configureUsage());
  }

  private configureUsage(): void {
    const goodId = this.goodId();

    this.usage$ = this.usageSource(goodId);
    this.changeDetectorRef.detectChanges();
  }

  private usageSource(
    goodId: Nillable<Guid>,
  ): Observable<Nillable<WarehouseGoodUsage>> {
    if (isNil(goodId)) {
      return of(null);
    }

    if (isEmptyString(goodId)) {
      return of(null);
    }

    return this.warehouseGoodDataSourceService.fetchGoodUsage(goodId);
  }
}
